import {createContext} from 'react'

export const DbContext = createContext();